import { useMediaQuery, useTheme } from '@mui/material';
import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import {
  contactsFullSelector,
  selectConfigurationParameterById,
  selectFavoriteEmail,
  userContactsSlice,
} from '!core/redux';
import { TrlScreenSummary, TrlTextWithLink } from '»components/atoms';
import { TrlGrid } from '»components/molecules/TrlGrid';

import { columns } from './TrlEmail.schema';
import { BoxStyled, TypographyStyled } from './TrlEmail.styles';

export const TrlEmail = () => {
  const dispatch = useDispatch();

  const theme = useTheme();

  const isMedium = useMediaQuery(theme.breakpoints.up('md'));
  const isLarge = useMediaQuery(theme.breakpoints.up('lg'));
  const isExtraLarge = useMediaQuery(theme.breakpoints.up('xl'));

  const { emails } = useSelector(contactsFullSelector);
  const favoriteEmail = useSelector(selectFavoriteEmail);
  const CONTACT_TYPE = useSelector((state) =>
    selectConfigurationParameterById(state, 'CONTACT_TYPE_EMAIL'),
  ).value;

  const [selectedEmail, setSelectedEmail] = useState(null);

  const selectedEmailToDisplay = selectedEmail ?? favoriteEmail;

  const handleFavoriteChange = (event) => {
    dispatch(
      userContactsSlice.actions.setFavoriteContactRequest({
        contactId: event.target.value,
        contactType: CONTACT_TYPE,
      }),
    );
  };

  const handleSelectedEmail = (email) => {
    setSelectedEmail(email);
  };

  useEffect(() => {
    dispatch(
      userContactsSlice.actions.userContactsRequest({
        contactType: CONTACT_TYPE,
      }),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {!isLarge ? (
        <TrlScreenSummary title="TRLT_UI-EMAIL" hasTopMargin>
          <TrlTextWithLink mainText="TRLT_UI-EMAIL_SELECTOR" />
        </TrlScreenSummary>
      ) : (
        <TrlTextWithLink mainText="TRLT_UI-EMAIL_SELECTOR" />
      )}
      <TrlGrid
        columns={columns({
          handleFavoriteChange,
          favoriteEmail: favoriteEmail?.contactId,
          theme,
          isExtraLarge,
          isLarge,
          isMedium,
        })}
        data={emails}
        selectedItem={selectedEmailToDisplay}
        selectedItemChange={handleSelectedEmail}
        dataItemKey="contactId"
        gridWidth={isLarge && '614px'}
      />
      {!isMedium && !isLarge && (
        <BoxStyled sx={{ display: 'flex' }}>
          <TypographyStyled className="selectedOptionDesc">
            <FormattedMessage id="TRLT_UI-DESCRIPTION" />:
          </TypographyStyled>
          <TypographyStyled className="descriptionValue">
            {selectedEmailToDisplay?.descr}
          </TypographyStyled>
        </BoxStyled>
      )}
    </>
  );
};
